import script from "./sidebar.vue?vue&type=script&lang=ts&setup=true"
export * from "./sidebar.vue?vue&type=script&lang=ts&setup=true"

import "./sidebar.vue?vue&type=style&index=0&id=71fbac44&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71fbac44"]])

export default __exports__